// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"256":"npm.chart.js-bf2cd571","416":"npm.chart.js-373d114a","825":"npm.xlsx"}[chunkId] || chunkId) + "." + {"59":"851d5c3c","256":"7dd949b7","260":"78469ea7","416":"df776731","563":"f9f4ea7a","635":"8a72fc72","677":"8835b310","825":"85a51195","977":"a44db78b"}[chunkId] + ".js";
};